const Login = () => import('@/views/login');

export default [
    {
        path: '/login',
        name:'login',
        meta: { name: '登录'},
        component: Login
    }
]